export function hasSourceFilePreview(row: {
  terminationFilePublicKeys?: string[]
  hasFlexspringSource?: boolean
}): boolean {
  return (
    (row.terminationFilePublicKeys?.length ?? 0) > 0 ||
    Boolean(row.hasFlexspringSource)
  )
}
